import axios from "axios";
import {ADMIN_DASHBOARD_ENDPOINT, ADMIN_PAYMENT_REQUEST_ENDPOINT, INVOICE_USAGE} from "../../constants/endpoints";
import {IOrderReportSearch, IResponseModel} from "../../models/DashboardModel";

export function getReport(params: IOrderReportSearch){
  return axios.get<IResponseModel>(`${ADMIN_DASHBOARD_ENDPOINT}/order`, {params});
}

export function getReportAbilities(params: IOrderReportSearch){
  return axios.get<IResponseModel>(`${ADMIN_DASHBOARD_ENDPOINT}/li-abilities`, {params});
}

export function getTotal(params: IOrderReportSearch) {
  return axios.get<IResponseModel>(`${ADMIN_DASHBOARD_ENDPOINT}/get-total`, {params});
}

export function getInvoiceUsage() {
  return axios.get<IResponseModel>(`${INVOICE_USAGE}`, {});
}

export function getPendingPaymentRequest() {
  return axios.get<IResponseModel>(`${ADMIN_PAYMENT_REQUEST_ENDPOINT}`, {params: {status: 'pending'}});
}